(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('stringArray', stringArray);

    function stringArray() {
        return function(value, delimiter) {
            if (!value) return '';
            value = JSON.parse(JSON.stringify(value));
            if (!(value instanceof Array)) return value;
            if (typeof delimiter == typeof undefined) { delimiter = ', '; }
            return value.join(delimiter);
        };
    }
})();